import React, { PropTypes } from 'react'

import HeroContainer from './HeroContainer';
import AboutOmniderm from './AboutOmniderm';
import ContactUs from './ContactUs';

const AboutContainer = (props) => {
  return (
    <div className="about">
      <HeroContainer />
      <AboutOmniderm />
      <ContactUs />
    </div>
  )
}

export default AboutContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/about/AboutContainer.jsx
 **/